import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AccountSignupConfirmationGuard implements CanMatch {

  constructor(private _cookieService: CookieService, private _router: Router) {
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const canContinue = this._cookieService.get('account-signup-confirmation-access') === 'true';

    if (canContinue) {
      return true;
    }

    return this._router.createUrlTree(['/sign-in']);
  }
}
